import { render, staticRenderFns } from "./HowWorks.vue?vue&type=template&id=27303534&"
import script from "./HowWorks.vue?vue&type=script&lang=js&"
export * from "./HowWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('27303534', component.options)
    } else {
      api.reload('27303534', component.options)
    }
    module.hot.accept("./HowWorks.vue?vue&type=template&id=27303534&", function () {
      api.rerender('27303534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/indexPartials/HowWorks.vue"
export default component.exports